<template>
  <div class="d-flex align-center">
    <user-avatar
      :user="user_"
      :size="size"
    />
    <div
      v-if="editing"
      class="ml-2"
    >
      <v-btn
        class="mx-2"
        color="secondary"
        outlined
        small
        @click="addFiles"
      >
        {{ $t('Upload') }}
        <input
          id="file"
          ref="file"
          accept="image/png, image/jpeg"
          class="d-none"
          type="file"
          @change="handleFileUpload"
        >
        <!--      <v-icon small>mdi-pencil</v-icon>-->
      </v-btn>

      <v-btn
        class="mx-2"
        outlined
        small
        @click="removeAvatar"
      >
        {{ $t('Delete') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
    import UserAvatar from "@/components/UserAvatar";

    import User from "@/mixins/User";
    import Me from "@/mixins/Me";

    export default {
        name: "UserAvatarOptions",

        components: {
            UserAvatar
        },

        mixins: [
            Me,
            User
        ],

        props: {
            user_: {
                type: Object,
                required: true
            },

            size: {
                type: Number,
                default: 36
            },

            editing: {
                type: Boolean,
                default: false
            },

            fetchUpdateUser: {
                type: Boolean,
                default: false
            },
        },

        methods: {
            async handleFileUpload() {
                let file = this.$refs.file.files[0];
                if (file) {
                    let formData = new FormData();
                    formData.append('id', this.user_.id);
                    formData.append('avatar', file);

                    this.setGlobalLoading(true);

                    await this.uploadUserAvatar(formData);

                    if (this.fetchUpdateUser) {
                        if (this.me.id === this.user_.id) {
                            await this.getMe()
                        } else {
                            await this.getOneUser({
                                id: this.user.id,
                                include: ['laboratory', 'groups', 'roles', 'country']
                            })
                        }
                    }

                    this.setGlobalLoading(false);
                    this.$emit('uploaded');
                    // this.$forceUpdate()
                }


            },

            addFiles() {
                this.$refs.file.click();
            },

            async removeAvatar() {
                this.setGlobalLoading(true);
                await this.removeUserAvatar({id: this.user_.id});

                if (this.fetchUpdateUser) {
                    if (this.me.id === this.user_.id) {
                        await this.getMe()
                    } else {
                        await this.getOneUser({
                            id: this.user_.id,
                            include: ['laboratory', 'groups', 'roles', 'country']
                        })
                    }
                }
                this.setGlobalLoading(false);
                this.$emit('removed');

                // this.$forceUpdate()
            }
        }
    }
</script>

<style scoped>

</style>
